import { render } from "./Submit_Ticket.vue?vue&type=template&id=3eed1eac&scoped=true"
import script from "./Submit_Ticket.vue?vue&type=script&lang=js"
export * from "./Submit_Ticket.vue?vue&type=script&lang=js"

import "./Submit_Ticket.vue?vue&type=style&index=0&id=3eed1eac&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eed1eac"]])

export default __exports__